<template>
  <div>
    <div class="shade" v-if="showShade">
      <!--预约上门评估成功 -->
      <div class="popup-container popPrompt" v-if="showAppointAssessSuccess">
        <div class="popup-close-img-container" @click="closePop">
          <img class="popup-close-img" src="../assets/icon_close_black-1.png" />
        </div>
        <div class="popup-hint-icon-container">
          <img class="popup-hint-icon" src="../assets/popup_img.png" />
        </div>
        <div class="popup-hint" v-html="isJoin==1?'您的2小时免费评估上门评估预约信息已成功发送，我们将尽快与您确认，请耐心等候！': '您的咨询信息已成功发送，<br>我们将在约定的时间与您联系，感谢您的支持！'"></div>
        <div class="clearboth"></div>
        <div class="popup-btn" @click="closePop">完成</div>
      </div>

      <!--提示框-->
      <div class="popup-container popPrompt" v-if="showPromptSuccess">
        <div class="popup-close-img-container" @click="closePop">
          <img class="popup-close-img" src="../assets/icon_close_black-1.png" />
        </div>
        <div class="popup-hint-icon-container">
          <img class="popup-hint-icon" src="../assets/popup_img.png" />
        </div>
        <div class="popup-hint" v-html="promptTxt"></div>
        <div class="clearboth"></div>
        <div class="popup-btn" @click="closePop">完成</div>
      </div>

    </div>

    <!--预约上门评估 -->
      <div class="popup-container popAppointAssess" v-if="showAppointAssess">
        <div class="popup-header">
          <div class="popup-close-img-container" @click="closePop">
            <img class="popup-close-img" src="../assets/icon_close_black.png" />
          </div>
          <div class="popup-header-content">
            <div class="popup-title-container">
              <div class="popup-title-cosmetic-line"></div>
              <div class="popup-title">预约上门评估</div>
              <div class="popup-title-cosmetic-line"></div>
            </div>
            <div class="popup-header-info-content">
              <div class="popup-header-info">
                <img class="popup-header-phrase-icon" src="../assets/home_popup_icon_service.png" />
                <div class="popup-header-phrase">2小时一对一咨询沟通</div>
                <div class="clearboth"></div>
              </div>
              <div class="popup-header-info">
                <img class="popup-header-phrase-icon" src="../assets/home_popup_icon_service.png" />
                <div class="popup-header-phrase">提效降险节流人事管理方案</div>
                <div class="clearboth"></div>
              </div>
              <div class="popup-header-info">
                <img class="popup-header-phrase-icon" src="../assets/home_popup_icon_service.png" />
                <div class="popup-header-phrase">分析自雇HR与外包成本</div>
                <div class="clearboth"></div>
              </div>
              <div class="popup-header-info">
                <img class="popup-header-phrase-icon" src="../assets/home_popup_icon_service.png" />
                <div class="popup-header-phrase">突发纠纷或问题员工紧急处理</div>
                <div class="clearboth"></div>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
        <div class="popup-content">
          <div class="popup-input">
            <label>您的姓名</label>
            <input ref="name" v-model="name" type="text" placeholder="请输入您的姓名" maxlength="100"/>
          </div>
          <div class="popup-input popPhone">
            <label>您的联系电话</label>
            <input ref="phone" v-model="phone" type="text" placeholder="请输入您的联系电话" maxlength="100"/>
            <div class="popup-code" v-if="codeShow" @click="toCreateCode">获取验证码</div>
            <div class="popup-code popup-code-unable" v-if="!codeShow" >{{count}}秒后重试</div>
          </div>
          <div v-if="isCodeInput" class="popup-input">
            <label>验证码</label>
            <input ref="code" v-model="code" type="text" placeholder="请输入验证码" maxlength="100"/>
          </div>
          <div class="popup-input">
            <label>其他联系方式（选填）</label>
            <input v-model="contact" type="text" placeholder="例：微信号123456" maxlength="200"/>
          </div>
          <div class="popup-input">
            <label>您还想通过咨询获得什么？（选填）</label>
            <textarea v-model="demand" rows="4" cols="20" placeholder="请输入您的需求" maxlength="1000"></textarea>
          </div>
          <div class="popup-activity">
            <div class="popup-activity-txt">限时活动</div>
            <div class="popup-activity-info">
              <img class="popup-activity-checkbox" @click="changeActivityCheckboxIconSrc()" :src="activityCheckboxIconSrc" />
              <div class="popup-activity-info-txt">
                预约免费上门评估服务&nbsp;-&nbsp;2小时面对面沟通
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <div class="popup-input" v-if="isJoin == 1">
            <label>请填写合适的上门服务时间</label>
            <input ref="serviceTime" v-model="serviceTime" type="text" :placeholder="'例：' + dateFormatPlaceHolderTime(placeHolderTime)" />
          </div>
          <div class="popup-txt">
            我们收到您的消息后将与您进行确认，请留意我们的后续联系
          </div>
          <div class="popup-btn" @click="toConsult">马上预约</div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
        showShade: true, //遮罩
        //免费上门预约弹窗-s
        name: "", //姓名
        phone: "", //联系电话
        contact: "", //其他联系方式
        demand: "", //需求
        isJoin: 1, //限时活动
        serviceTime: "", //上门服务时间
        //免费上门预约弹窗-e
        placeHolderTime: new Date(),
        activityCheckboxIconSrc: require("../assets/form_activity_icon_selected.png"),

        code: "",
        count: '',
        timer: null,
        codeShow: true,
        isCodeInput: false,
    };
  },
  props: {
    //免费上门评估
    showAppointAssess: {
      type: Boolean,
      default: ()=>{
        return false;
      },
    },
    //预约上门评估成功
    showAppointAssessSuccess: {
      type: Boolean,
      default: ()=>{
        return false;
      },
    },
    //提示成功
    showPromptSuccess: {
      type: Boolean,
      default: ()=>{
        return false;
      },
    },
    promptTxt: {
      type: String,
      default: ()=>{
        return "";
      },
    }

  },
  mounted(){
  },
  methods: {
    //格式化当前日期 弹窗提示文字 xx年xx月xx日上午x点 
    dateFormatPlaceHolderTime(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours =
        date.getHours() < 12
          ? "上午" + date.getHours()
          : "下午" + (date.getHours() - 12);

      return year + "年" + month + "月" + day + "日" + hours + "点";
    },
    //弹窗限时活动，点击改src
    changeActivityCheckboxIconSrc() {
      if (this.isJoin == 1) {
        this.isJoin = 2;
      } else {
        this.isJoin = 1;
      }
      switch (this.isJoin) {
        case 1:
          this.activityCheckboxIconSrc = require("../assets/form_activity_icon_selected.png");
          break;
        case 2:
          this.activityCheckboxIconSrc = require("../assets/form_activity_icon_unselected.png");
          break;
      }
    },
   
    //关闭弹窗
    closePop() {
      this.$emit('closePop')
      //this.$emit('update:showAppointAssess',false)
      //this.$emit('closePop')
    },
    //关闭免费预约上门弹窗，打开预约上门成功弹窗
    toShowAppointAssessSuccess() {
      this.$emit('toShowAppointAssessSuccess')
    },
    
    //免费上门评估 弹窗 预约提交
    toConsult() {
     
      if(this.name==""){
          alert("请填写您的姓名")
          this.$refs.name.focus()
          return false
      }
      var phonereg = /^[1][3,4,5,7,8][0-9]{9}$/
      if(this.phone==""){
          alert("请填写您的联系电话")
          this.$refs.phone.focus()
          return false
      }else if(!phonereg.test(this.phone)){
          alert("您的联系电话格式有误，请重新填写")
          this.$refs.phone.focus()
          return false
      }
      if(this.code==""){
          alert("请填写验证码")
          this.$refs.code.focus()
          return false
      }else if(this.code!=document.getElementById("randomCode").innerText){
          alert("验证码不正确，请重新输入")
          this.code=""
          this.$refs.code.focus()
          return false
      }

      if(this.isJoin==1 && this.serviceTime==""){
          alert("请填写上门服务时间")
          this.$refs.serviceTime.focus()
          return false
      }
     
      let params = {};
      params.type = 1;
      params.name = this.name;//姓名
      params.phone = this.phone;//联系电话
      params.contact = this.contact;//其他联系方式
      params.demand = this.demand;//需求
      params.isJoin = this.isJoin;//限时活动
      params.serviceTime = this.serviceTime;//上门服务时间
      params.browserId = sessionStorage.getItem("Finger");//浏览器标识
      axios
        .post("pilotage/webConsult", params)
        .then((res) => {
          if(res!=null && res.data!=null){
              if(res.data.success!=null && res.data.success==1){
                  this.toShowAppointAssessSuccess()
              }else if(res.data.success!=null && res.data.success==3){
                  this.closePop()
                  alert("您已提交，请勿重复提交，请耐心等待回复！")
              }else{
                alert("提交失败，请您重新提交！")
              }
          }
        })
        .catch((res) => {
          alert("提交失败，请您重新提交！")
        });
     
    },

    //创建验证码
    toCreateCode(){
      var phonereg = /^[1][3,4,5,7,8][0-9]{9}$/
      if(this.phone==""){
        alert("请填写您的联系电话")
        this.$refs.phone.focus()
        return false
      }else if (phonereg.test(this.phone)) {
        this.isCodeInput = true;
        createRandomCode();

        let params = {};
        params.type = 1;
        params.phone = this.phone;//联系电话
        params.code = document.getElementById("randomCode").innerText;//联系电话
        
        axios
          .post("pilotage/sendCode", params)
          .then((res) => {
            if(res!=null && res.data!=null){
              
            }
          })
          .catch((res) => {
          });

        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.codeShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
               this.count--;
            } else {
               this.codeShow = true;
               clearInterval(this.timer);
               this.timer = null;
            }
         }, 1000)
      
        }

      }else{
        alert("您的联系电话格式有误，请重新填写")
        this.$refs.phone.focus()
        return false
      }
    },

  },
};
</script>

<style>
.div-shade-show {
    height: 1180px;
    overflow: hidden;
}

.shade {
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.5);
  right: 0px;
  bottom: 0px;
  z-index: 99;
}

.clearboth {
  clear: both;
}

.popup-container {
  width: 740px;
  height: auto;
  margin: auto;
  position: fixed;
  top: 78px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 200;
}
.popAppointAssess.popup-container{
  position: absolute;
}
.popAppointAssess .popup-header {
  background: #1055c1;
  position: relative;
  width: 100%;
}

.popup-close-img-container {
  cursor: pointer;
  position: absolute;
  top: 29px;
  right: 34px;
}

.popup-close-img {
  width: 24px;
  height: auto;
}

.popAppointAssess .popup-header-content {
  padding: 20px 0 24px 0;
  text-align: center;
}

.popAppointAssess .popup-title-container {
  font-size: 0;
}

.popAppointAssess .popup-title-cosmetic-line {
  width: 100px;
  height: 1.2px;
  margin: 10px 20px;
  display: inline-block;
}

.popAppointAssess
  .popup-title-container
  .popup-title-cosmetic-line:first-child {
  background-image: linear-gradient(
    to right,
    rgb(255, 255, 255, 0),
    rgb(255, 255, 255, 1)
  );
}

.popAppointAssess
  .popup-title-container
  .popup-title-cosmetic-line:nth-child(3) {
  background-image: linear-gradient(
    to right,
    rgb(255, 255, 255, 1),
    rgb(255, 255, 255, 0)
  );
}

.popAppointAssess .popup-title {
  font-family: Noto Sans SC;
  font-size: 26px;
  line-height: 36px;
  color: #ffffff;
  display: inline-block;
}

.popAppointAssess .popup-header-info-content {
  margin: 20px 0 0 0;
}

.popAppointAssess .popup-header-info {
  float: left;
  margin: 16px 0 0 0;
  height: 28px;
}

.popAppointAssess .popup-header-info:nth-child(-n + 2) {
  margin-top: 0px;
}

.popAppointAssess .popup-header-info:nth-child(odd) {
  margin-left: 145px;
}

.popAppointAssess .popup-header-phrase-icon {
  height: 24px;
  width: auto;
  float: left;
  margin: 2px 4px 0 0;
}

.popAppointAssess .popup-header-phrase {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 28px;
  color: #ffffff;
  width: 208px;
  float: left;
  text-align: left;
}

.popAppointAssess .popup-content {
  background: #eef4fe;
  text-align: center;
  padding: 20px 0;
}

.popAppointAssess .popup-input {
  margin: 15px 0px 0 0;
}

.popAppointAssess .popup-content .popup-input:first-child {
  margin-top: 0px;
}

.popAppointAssess .popup-input label {
  text-align: left;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #333333;
  display: block;
  margin: 0 0 0 110px;
}

.popAppointAssess .popup-input input {
  margin: 8px 0 0 0;
  width: 500px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ffffff;
  padding: 0 8px;
  font-size: 16px;
  line-height: 24px;
  font-family: Noto Sans SC;
  color: #333333;
}

.popAppointAssess .popup-input textarea {
  margin: 8px 0 0 0;
  width: 500px;
  height: 120px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ffffff;
  resize: none;
  padding: 8px 8px;
  font-size: 16px;
  line-height: 24px;
  font-family: Noto Sans SC;
  color: #333333;
}

.popAppointAssess .popup-input.popPhone input{
  width: 376px;
}

.popAppointAssess .popup-input.popPhone .popup-code{
  margin-left: 4px;
  background: #1055c1;
  border-radius: 5px;
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 14px;
  line-height: 42px;
  text-align: center;
  color: #FFFFFF;
  height: 42px;
  cursor: pointer;
  width: 120px;
  display: inline-block;
}

.popAppointAssess .popup-input.popPhone .popup-code-unable{
  background: #c9c9c9;
  cursor: auto;
}

.popAppointAssess .popup-input input::-webkit-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
}

.popAppointAssess .popup-input input:-moz-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
}

.popAppointAssess .popup-input input:-ms-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 40px;
}

.popAppointAssess .popup-input textarea::-webkit-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.popAppointAssess .popup-input textarea:-moz-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.popAppointAssess .popup-input textarea:-ms-input-placeholder {
  color: #b7cced;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
}

.popAppointAssess .popup-activity {
  position: relative;
  background: #ffffff;
  border-radius: 4px;
  width: 516px;
  height: 86px;
  margin: 15px 0 0 0;
  display: inline-block;
}

.popAppointAssess .popup-activity-txt {
  font-family: Noto Sans SC;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  width: 80px;
  height: 24px;
  background: #1055c1;
  border-radius: 0px 0px 4px 0px;
  position: absolute;
  top: 0;
  left: 0;
}

.popAppointAssess .popup-activity-info {
  margin: 39px 0 0 49px;
}

.popAppointAssess .popup-activity-checkbox {
  height: 24px;
  width: auto;
  float: left;
  margin: 3px 14px 0 0;
  cursor: pointer;
}

.popAppointAssess .popup-activity-info-txt {
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #1055c1;
  float: left;
}

.popAppointAssess .popup-txt {
  font-family: Noto Sans SC;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  color: #666666;
  margin: 20px 0 0 0;
}

.popup-btn {
  background: #1055c1;
  border-radius: 10px;
  font-family: Noto Sans SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 56px;
  text-align: center;
  color: #ffffff;
  width: 180px;
  height: 56px;
  display: inline-block;
  margin: 16px 0 0 0;
  cursor: pointer;
}

.popPrompt.popup-container {
  width: 840px;
  top: 80px;
  background: #ffffff;
  text-align: center;
  padding: 99px 0 98px 0;
}

.popPrompt .popup-close-img-container {
  top: 24px;
  right: 24px;
}

.popup-hint-icon-container {
}

.popup-hint-icon {
  height: 145px;
  width: auto;
}

.popup-hint {
  font-family: Noto Sans SC;
  font-size: 24px;
  line-height: 40px;
  text-align: center;
  color: #1055c1;
  width: 545px;
  display: inline-block;
  margin: 62px 0 0 0;
}

.popPrompt .popup-btn {
  margin: 51px 0 0 0;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/popup.vue